import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { Section } from '../../../../components/ui/Section';
import { BlockedItemRow, CatalogueGovernanceClient } from '../../../../app/services/api/catalogueGovernance';
import ApprovalStatusChip from './ApprovalStatusChip';

const BlockedItemsTab = () => {
  const { t } = useTranslation('catalogueGovernance');
  const [rows, setRows] = useState<BlockedItemRow[]>([]);

  const load = () => CatalogueGovernanceClient.getBlockedItems().then(setRows);

  useEffect(() => {
    load();
  }, []);

  const handleUnblock = async (id: string) => {
    await CatalogueGovernanceClient.unblockItem(id);
    load();
  };

  return (
    <Section>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('blockedItems.columnProduct', 'Product')}</TableCell>
            <TableCell>{t('blockedItems.columnSupplier', 'Supplier')}</TableCell>
            <TableCell>{t('blockedItems.columnCatalogue', 'Catalogue')}</TableCell>
            <TableCell>{t('blockedItems.columnReason', 'Reason')}</TableCell>
            <TableCell>{t('blockedItems.columnBlockedSince', 'Blocked since')}</TableCell>
            <TableCell>{t('blockedItems.columnBlockedBy', 'Blocked by')}</TableCell>
            <TableCell>{t('blockedItems.columnAffectedSites', 'Affected sites')}</TableCell>
            <TableCell>{t('blockedItems.columnStatus', 'Status')}</TableCell>
            <TableCell>{t('blockedItems.columnActions', 'Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow><TableCell colSpan={9}>{t('blockedItems.emptyState', 'No blocked items to show.')}</TableCell></TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.product}</TableCell>
              <TableCell>{row.supplier}</TableCell>
              <TableCell>{row.catalogue}</TableCell>
              <TableCell>{row.reason}</TableCell>
              <TableCell>{row.blockedSince}</TableCell>
              <TableCell>{row.blockedBy}</TableCell>
              <TableCell>{row.affectedSites}</TableCell>
              <TableCell><ApprovalStatusChip status={row.status} /></TableCell>
              <TableCell>
                <Button size="md"
                  variant="secondary"
                  disabled={row.status === 'Unblocked'}
                  onClick={() => handleUnblock(row.id)}>
                  {t('blockedItems.actionUnblock', 'Unblock')}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Section>
  );
};

export default BlockedItemsTab;
